var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    _vm._g(
      {
        attrs: {
          width: "24",
          height: "24",
          viewBox: "0 0 24 24",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
        },
      },
      _vm.$listeners
    ),
    [
      _c("path", {
        attrs: {
          d: "M12 13c0 2.761-1.239 5-4 5s-4-2.239-4-5 1.239-5 4-5 4 2.239 4 5z",
          stroke: "#000",
          "stroke-width": "2",
          "stroke-linecap": "round",
        },
      }),
      _c("circle", { attrs: { cx: "6", cy: "5", r: "1", fill: "#000" } }),
      _c("circle", { attrs: { cx: "10", cy: "5", r: "1", fill: "#000" } }),
      _c("path", {
        attrs: {
          d: "M6 5l2-1.5L10 5",
          stroke: "#000",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
        },
      }),
      _c("path", {
        attrs: {
          d: "M16 12v6M19.5 12c-3 1-3.5 3.5-3.5 3.5M18 9l1-1.5",
          stroke: "#000",
          "stroke-width": "2",
          "stroke-linecap": "round",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }